<section class="wrapper">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close">
      <mat-icon>close</mat-icon>
    </button>
    <h1>Add Organisation</h1>
  </section>
  <form (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
    <section mat-dialog-content>
      <mat-form-field>
        <input
          type="text"
          placeholder="Title"
          formControlName="title"
          matInput
          />
      </mat-form-field>
      <mat-form-field>
        <input
          type="text"
          placeholder="Menu Title"
          formControlName="menu_title"
          matInput
          />
      </mat-form-field>
      <mat-form-field>
        <input
          type="text"
          placeholder="Listing Id"
          formControlName="product_id"
          matInput
          />
      </mat-form-field>
      <mat-form-field
        ><mat-label>Category</mat-label>
        <mat-select formControlName="category_id">
          @for (category of categories; track category) {
            <mat-option [value]="category.id"
              >{{ category.title }}</mat-option
              >
            }
          </mat-select>
        </mat-form-field>
      </section>
      <section align="end" mat-dialog-actions>
        <button
          mat-button
          mat-dialog-close
          matTooltip="Cancel and close."
          type="button"
          >
          <mat-icon>cancel</mat-icon>
          Cancel
        </button>
        <button
          [disabled]="!form.valid"
          mat-button
          matTooltip="Save organisation"
          type="submit"
          >
          <mat-icon>done</mat-icon>
          Done
        </button>
      </section>
    </form>
  </section>
